import { takeEvery } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

function* updateShipmentParamUrl({ payload }: PayloadAction<string>) {
  const newUrl = window.location.protocol + window.location.pathname + `?sendung=${payload}`;
  window.history.replaceState(null, '', newUrl);
}

export function* ShipmentNumberSaga() {
  yield takeEvery('shipment/setShipmentNumber', updateShipmentParamUrl);
}
